'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (valueOrFunction) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
    }

    if (typeof valueOrFunction === 'function') {
        return valueOrFunction.apply(undefined, args);
    }

    return valueOrFunction;
};


//////////////////
// WEBPACK FOOTER
// ./~/aor-simple-graphql-client/lib/getOrCall.js
// module id = 929
// module chunks = 0